module.exports = __webpack_public_path__ + "static/media/agricultural7.aeda25ab.jpg";